import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Context} from "../../App";
import DB_Branch from "../../database/dictionary/branch";
import ModalWindow from "../modal";
import {Outlet, useNavigate} from "react-router-dom";
import {Button, Col, DatePicker, Form, PageHeader, Row, Select, Space, Switch, Table} from "antd";
import {ReloadOutlined, SearchOutlined} from "@ant-design/icons";
import moment from "moment/moment";
import DB_ReportSale from "../../database/reports/db_report_sale";

const ReportSales = () => {
    const {token, defaultPageSize, defaultPage, setToken} = useContext(Context);
    const {getActiveBranches} = DB_Branch(token)
    const {getReportSale} = DB_ReportSale(token)
    const {t} = useTranslation()
    const {errorConnect} = ModalWindow()
    const navigate = useNavigate()
    const [data, setData] = useState()
    const [wait, setWait] = useState(false)
    const [form] = Form.useForm()
    const [typePicker, setTypePicker] = useState('day')
    const [formatPicker, setFormatPicker] = useState('DD.MM.YYYY')
    const [branch, setBranch] = useState([])
    const [orgStructureSwitch, setOrgStructureSwitch] = useState(false)
    const [date, setDate] = useState({
        startDate: null,
        endDate: null,
        date: null
    })

    const filterDate = (date, dateString) => {
        if (date == null) {
            setDate({
                startDate: null,
                endDate: null,
                date: null
            })
        } else {
            switch (typePicker) {
                case 'week': {
                    setDate({
                        startDate: date.startOf('week').format("YYYY-MM-DD"),
                        endDate: date.endOf('week').format("YYYY-MM-DD"),
                        date: moment(date)
                    })
                    break
                }

                case 'month': {
                    setDate({
                        startDate: date.startOf('month').format("YYYY-MM-DD"),
                        endDate: date.endOf('month').format("YYYY-MM-DD"),
                        date: moment(date)
                    })
                    break
                }

                case 'quarter': {
                    setDate({
                        startDate: date.startOf('quarters').format("YYYY-MM-DD"),
                        endDate: date.endOf('quarters').format("YYYY-MM-DD"),
                        date: moment(date)
                    })
                    break
                }

                case 'year': {
                    setDate({
                        startDate: date.startOf('years').format("YYYY-MM-DD"),
                        endDate: date.endOf('years').format("YYYY-MM-DD"),
                        date: moment(date)
                    })
                    break
                }
                default : {
                    setDate({
                        startDate: date.format("YYYY-MM-DD"),
                        endDate: date.format("YYYY-MM-DD"),
                        date: moment(date)
                    })
                }

            }

            switch (typePicker) {
                case 'day':
                    setFormatPicker('DD.MM.YYYY');
                    break;
                case 'week':
                    setFormatPicker('wo YYYY');
                    break;
                case 'month':
                    setFormatPicker('MMMM YYYY');
                    break;
                case 'quarter':
                    setFormatPicker('\\QQ YYYY');
                    break;
                case 'year':
                    setFormatPicker('YYYY');
                    break;
            }
        }

    }
    const changeTypePicker = (e) => {
        setTypePicker(e)
        setDate({
            startDate: null,
            endDate: null,
            date: null
        })
    }

    const clearFilter = () => {
        setDate({
            startDate: null,
            endDate: null,
            date: null
        })

        form.setFieldsValue({
                org_structure: [],
                invoice_number: null,
                doc_type: null,
                trade_point: [],
                branch: null,
            }
        )
    }

    const Filters = () => {
        return (
            <>
                <Form
                    form={form}
                    name="advanced_search"
                    className="ant-advanced-search-form"
                    layout={"vertical"}
                    style={{marginTop: '-10pt'}}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            getData()
                        }
                    }}
                >
                    <Row gutter={16}>
                        <Col span={8}>
                            <Form.Item
                                name={t('date')}
                                label={t('date')}
                            >
                                <Row gutter={8}>

                                    <Col span={8}>
                                        <Select value={typePicker} onChange={changeTypePicker}>
                                            <Select.Option value="day">{t('day')}</Select.Option>
                                            <Select.Option value="week">{t('week')}</Select.Option>
                                            <Select.Option value="month">{t('month')}</Select.Option>
                                            <Select.Option value="quarter">{t('quarter')}</Select.Option>
                                            <Select.Option value="year">{t('year')}</Select.Option>
                                        </Select>
                                    </Col>
                                    <Col span={16}>
                                        <DatePicker value={date.date != null ? date.date : null}
                                                    picker={typePicker}
                                                    onChange={e => filterDate(e)}
                                                    format={formatPicker}
                                        />
                                    </Col>
                                </Row>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                name='branch'
                                label={t('branch')}
                            >
                                <Select
                                    showSearch
                                    optionFilterProp="name"
                                    optionLabelProp="name"
                                    allowClear>
                                    {branch.map(b =>
                                        <Select.Option key={b.id} value={b.id} name={b.name}>{b.name}</Select.Option>
                                    )}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item
                                name='org_structure'
                                label={t('org_structure_s')}
                            >
                                {/*<DebounceSelect*/}
                                {/*    // mode="multiple"*/}
                                {/*    showSearch*/}
                                {/*    //fetchOptions={getOrgStructureFilter}*/}
                                {/*/>*/}
                                <Switch defaultChecked={orgStructureSwitch} onChange={setOrgStructureSwitch}/>
                            </Form.Item>
                        </Col>
                    </Row>
                    {/*</Form.Item>*/}
                    {/*    </Col>*/}
                    {/*    <Col span={8}>*/}
                    {/*        <Form.Item*/}
                    {/*            name='org_structure'*/}
                    {/*            label={t('org_structure_s')}*/}
                    {/*        >*/}
                    {/*            <DebounceSelect*/}
                    {/*                // mode="multiple"*/}
                    {/*                showSearch*/}
                    {/*                //fetchOptions={getOrgStructureFilter}*/}
                    {/*            />*/}
                    {/*        </Form.Item>*/}
                    {/*    </Col>*/}
                    {/*    /!*<Col span={8}>*!/*/}
                    {/*    /!*    <Form.Item*!/*/}
                    {/*    /!*        name='trade_point'*!/*/}
                    {/*    /!*        label={t('trade_point')}*!/*/}
                    {/*    /!*    >*!/*/}
                    {/*    /!*        <DebounceSelect*!/*/}
                    {/*    /!*            // mode="multiple"*!/*/}
                    {/*    /!*            showSearch*!/*/}
                    {/*    /!*            fetchOptions={getTradePointFilter}*!/*/}
                    {/*    /!*        />*!/*/}
                    {/*    /!*    </Form.Item>*!/*/}
                    {/*    /!*</Col>*!/*/}
                    {/*</Row>*/}
                    {/*<Row gutter={16}>*/}
                    {/*    <Col span={8}>*/}
                    {/*        <Form.Item*/}
                    {/*            name='invoice_number'*/}
                    {/*            label={t('invoice_number')}*/}
                    {/*        >*/}
                    {/*            <Input allowClear/>*/}
                    {/*        </Form.Item>*/}
                    {/*    </Col>*/}
                    {/*    <Col span={8}>*/}
                    {/*        <Form.Item*/}
                    {/*            name='doc_type'*/}
                    {/*            label={t('doc_type')}*/}
                    {/*        >*/}
                    {/*            <Select allowClear>*/}
                    {/*                {docType.map(d =>*/}
                    {/*                    <Select.Option key={d.id} value={d.id} name={d.name}>{d.name}</Select.Option>*/}
                    {/*                )}*/}
                    {/*            </Select>*/}
                    {/*        </Form.Item>*/}
                    {/*    </Col>*/}
                    {/*    <Col span={8}>*/}
                    {/*        <Form.Item*/}
                    {/*            name='branch'*/}
                    {/*            label={t('branch')}*/}
                    {/*        >*/}
                    {/*            <Select*/}
                    {/*                showSearch*/}
                    {/*                optionFilterProp="name"*/}
                    {/*                optionLabelProp="name"*/}
                    {/*                allowClear>*/}
                    {/*                {branch.map(b =>*/}
                    {/*                    <Select.Option key={b.id} value={b.id} name={b.name}>{b.name}</Select.Option>*/}
                    {/*                )}*/}
                    {/*            </Select>*/}
                    {/*        </Form.Item>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}
                </Form>
                <Space
                    style={{marginTop: '-10pt', marginBottom: '20pt', width: '100%', justifyContent: 'flex-end'}}>
                    <Button icon={<ReloadOutlined/>} onClick={clearFilter}>{t('clear')}</Button>
                    <Button type={"primary"} icon={<SearchOutlined/>}
                            onClick={e => getData()}>{t('search')}</Button>
                </Space>

            </>
        )
    }


    const columns = [
        {
            title: t('weight'),
            dataIndex: 'kg',
        },
        {
            title: t('sum_with_tax'),
            dataIndex: 'sum_with_tax',
        },

    ]

    const columns_org_structure = [
        {
            title: t('code'),
            dataIndex: 'orgStructure_id',
        },
        {
            title: t('org_structure'),
            dataIndex: 'name',
        },
        {
            title: t('weight'),
            dataIndex: 'kg',
        },
        {
            title: t('sum_with_tax'),
            dataIndex: 'sum_with_tax',
        },
    ]


    useEffect(() => {
        window.scrollTo(0, 0)
        getActiveBranches()
            .then(res => {
                setBranch(res.data)
            })
            .catch((e) => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                    console.log(e)
                }
            })
    }, [])


    const getData = () => {
        setWait(true)

        //
        // if (page == null) {
        //     page = defaultPage
        // }
        // setSearchParams({page: page})
        //
        const formData = new FormData
        formData.append('date_start', date.startDate)
        formData.append('date_end', date.endDate)
        formData.append('branch', form.getFieldValue('branch'))
        formData.append('org_structure', form.getFieldValue('org_structure'))

        // if (showFilters) {
        //     formData.append('date_start', date.startDate)
        //     formData.append('date_end', date.endDate)
        //     formData.append('invoice_number', form.getFieldValue('invoice_number'))
        //     formData.append('org_structure', form.getFieldValue('org_structure') === [] || form.getFieldValue('org_structure') == null ? null : form.getFieldValue('org_structure').value)
        //     // formData.append('org_structure', form.getFieldValue('org_structure').map(u => u.value)) // if mode - multiple
        //     formData.append('doc_type', form.getFieldValue('doc_type'))
        //     formData.append('trade_point', form.getFieldValue('trade_point') === [] || form.getFieldValue('trade_point') == null ? null : form.getFieldValue('trade_point').value)
        //     // formData.append('trade_point', form.getFieldValue('trade_point').map(u => u.value)) // if mode - multiple
        //     formData.append('branch', form.getFieldValue('branch'))
        // }
        //
        //
        getReportSale(formData)
            .then(res => {
                setData(res.data);
                setWait(false);
            })
            .catch((e) => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                    console.log(e)
                }
            })

    }

    return (
        <div>
            <div className="page">
                <PageHeader
                    className="site-page-header"
                    title={t("report_sales")}
                />

                {/*<Space style={{width: '100%', justifyContent: 'flex-end', marginBottom: '10pt'}}>*/}
                {/*    <Button type={showFilters ? "default" : "text"} icon={<FilterOutlined/>}*/}
                {/*            onClick={e => setShowFilters(!showFilters)}>{t('filters')}</Button>*/}
                {/*</Space>*/}

                {/*{showFilters ? <Filters/> : null}*/}
                <Filters/>

                <Table
                    columns={orgStructureSwitch ? columns_org_structure : columns}
                    dataSource={data}
                    rowKey="id"
                    loading={wait}
                    pagination={false}
                    size={"small"}
                />

            </div>
            <Outlet/>
        </div>
    )

}
export default ReportSales